export const serviceData = {
  service:[
    {
      id: 0,
      name: "Google Ads",
    },
    {
      id: 1,
      name: "Facebook Ads",
    },
    {
      id: 2,
      name: "Yandex Direct",
    },
    {
      id: 3,
      name: "SEO",
    },
  ],
  budget:[
    {
      id: 0,
      title:"до 6.000.000 cум",
    },
    {
      id: 1,
      title:"от 6 млн. до 12 млн cум",
    },
    {
      id: 2,
      title:"от 12 млн. до 25 млн cум",
    },
    {
      id: 3,
      title:"от 25 млн сум и больше.",
    },
  ],
};
